import { render, staticRenderFns } from "./EscolhePlantonista.vue?vue&type=template&id=f598f86a&scoped=true"
import script from "./EscolhePlantonista.vue?vue&type=script&lang=js"
export * from "./EscolhePlantonista.vue?vue&type=script&lang=js"
import style0 from "./EscolhePlantonista.vue?vue&type=style&index=0&id=f598f86a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f598f86a",
  null
  
)

export default component.exports